import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getTheme } from "../api";
import { themesKeys } from "./keys";
import type { Theme } from "../../types";

export const useThemeQuery = (id: number | string | undefined) => {
  return useQuery<Theme>({
    queryKey: themesKeys.detail(id),
    queryFn: async () => {
      const { data } = await getTheme(id!);
      return data;
    },
    enabled: !!id,
    ...reactQueryCacheAndRefetchOptions,
  });
};
